import { Spacer } from '@perch-labs/shrike';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

export const Separator = styled(Spacer)<SpaceProps>`
  padding: 32px 0;
  ${space}
`;
